var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import React from 'react';
import { COLOR, colors } from '../../../theme/colors';
import { useEnvironment } from '../../providers/env';
export const Icon = (_a) => {
    var { icon, size, color, sx, onClick } = _a, rest = __rest(_a, ["icon", "size", "color", "sx", "onClick"]);
    const InnerComponent = icon;
    const { flagInDevelopment } = useEnvironment();
    if (onClick && !rest['aria-label']) {
        flagInDevelopment('Icon component with onClick should have an aria-label and tabIndex={0}');
    }
    return (_jsx("div", Object.assign({ tabIndex: onClick ? 0 : undefined, role: onClick ? 'button' : 'none', onClick: onClick, sx: Object.assign(Object.assign({}, sx), { fontSize: size, display: 'flex', alignItems: 'center', justifyContent: 'center', ':hover': onClick
                ? {
                    cursor: 'pointer',
                    transform: 'scale(1.05)',
                }
                : {} }) }, rest, { children: React.createElement(InnerComponent, {
            fontSize: 'inherit',
            style: {
                color: colors[color || COLOR.PRIMARY],
            },
        }) })));
};
